import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ProContext = createContext();

export const usePro = () => useContext(ProContext);

const API = '/api';

export function ProProvider({ children }) {
  const [proUser, setProUser] = useState(null);
  const [proLoading, setProLoading] = useState(true);

  const getProToken = useCallback(() => localStorage.getItem('blc_pro_token'), []);

  const proFetch = useCallback(async (method, path, data = null) => {
    const token = getProToken();
    const config = { headers: { Authorization: `Bearer ${token}` } };
    if (method === 'get') return axios.get(`${API}${path}`, config);
    if (method === 'post') return axios.post(`${API}${path}`, data, config);
    if (method === 'put') return axios.put(`${API}${path}`, data, config);
    if (method === 'delete') return axios.delete(`${API}${path}`, config);
  }, [getProToken]);

  useEffect(() => {
    const token = getProToken();
    const cached = localStorage.getItem('blc_pro_user');
    if (token && cached) {
      try {
        setProUser(JSON.parse(cached));
        axios.get(`${API}/pro/me`, { headers: { Authorization: `Bearer ${token}` } })
          .then(r => {
            setProUser(r.data);
            localStorage.setItem('blc_pro_user', JSON.stringify(r.data));
          }).catch(() => proLogout());
      } catch {
        proLogout();
      }
    }
    setProLoading(false);
  }, [getProToken]);

  const proLogin = async (email, password) => {
    try {
      const response = await axios.post(`${API}/pro/login`, { email, password });
      const { token, company } = response.data;
      localStorage.setItem('blc_pro_token', token);
      localStorage.setItem('blc_pro_user', JSON.stringify(company));
      setProUser(company);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Erreur de connexion'
      };
    }
  };

  const proRegister = async (data) => {
    try {
      const response = await axios.post(`${API}/pro/register`, data);
      const { token, company } = response.data;
      localStorage.setItem('blc_pro_token', token);
      localStorage.setItem('blc_pro_user', JSON.stringify(company));
      setProUser(company);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || "Erreur lors de l'inscription"
      };
    }
  };

  const proLogout = () => {
    localStorage.removeItem('blc_pro_token');
    localStorage.removeItem('blc_pro_user');
    setProUser(null);
  };

  const refreshPro = async () => {
    try {
      const token = getProToken();
      const response = await axios.get(`${API}/pro/me`, { headers: { Authorization: `Bearer ${token}` } });
      setProUser(response.data);
      localStorage.setItem('blc_pro_user', JSON.stringify(response.data));
    } catch {}
  };

  return (
    <ProContext.Provider value={{ proUser, proLoading, proLogin, proRegister, proLogout, refreshPro, proFetch }}>
      {children}
    </ProContext.Provider>
  );
}
